import './Header.css';
import { DOMAINS, getCurrentEnvironment } from '../../utils/constants';

export interface HealthStatus {
  status: 'healthy' | 'degraded' | 'unhealthy';
  health_score?: number;
}

export interface HeaderProps {
  showDietitiansLink?: boolean;
  logoLink?: string;
  className?: string;
  // Admin-specific props
  healthStatus?: HealthStatus;
  userName?: string;
  onLogout?: () => void;
  title?: string; // For admin dashboard title
}

const Header = ({ 
  showDietitiansLink = false,
  logoLink,
  className = '',
  healthStatus,
  userName,
  onLogout,
  title
}: HeaderProps) => {
  // Determine logo link based on environment if not provided
  const env = getCurrentEnvironment();
  const defaultLogoLink = logoLink || (env === 'local' 
    ? DOMAINS.LOCAL.WEBSITE 
    : DOMAINS.PRODUCTION.WEBSITE);
  
  // Determine dietitians link based on environment
  const dietitiansLink = env === 'local'
    ? `${DOMAINS.LOCAL.PORTAL}/login`
    : `${DOMAINS.PRODUCTION.PORTAL}/login`;
  const headerClasses = [
    className,
    title ? 'header-admin-dashboard' : ''
  ].filter(Boolean).join(' ');

  return (
    <header className={headerClasses || ''}>
      <div className="header-content">
        <div className="header-left">
          <a href={defaultLogoLink} className="header-logo">
            <img src="/images/zivo_logo.png" alt="ZivoHealth" className="header-logo-img" />
          </a>
        </div>
        {title && (
          <div className="header-center">
            <h1 className="header-title">{title}</h1>
          </div>
        )}
        <div className="header-right">
          {showDietitiansLink && (
            <nav className="header-nav">
              <a href={dietitiansLink}>For Doctors</a>
            </nav>
          )}
          {healthStatus && healthStatus.status && (
            <div className="header-health-status">
              <div className={`header-status-dot ${healthStatus.status}`}></div>
              <span className="header-status-text">
                {healthStatus.status.toUpperCase()} • {healthStatus.health_score || 0}%
              </span>
            </div>
          )}
          {userName && (
            <div className="header-user-info">
              <span>Welcome, {userName}</span>
              {onLogout && (
                <button onClick={onLogout} className="header-logout-button">Logout</button>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
